import { saveAs } from 'file-saver';
import XlsxPopulate from "xlsx-populate/browser/xlsx-populate";

export function exportDataExcel(sheetData, mainTitle, widthObj, extention, total) {
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const sheet1 = workbook.sheet(0);
        const totalColumns = sheetData[0].length;
        const range = sheet1.usedRange();
        const endColumn = String.fromCharCode(64 + totalColumns);

        sheet1.cell("A2").value(sheetData);
        sheet1.range("A2:" + endColumn + "1").style({
            horizontalAlignment: "center",
            verticalAlignment: "center",
            bold: true,
            border: true,
            fontSize: 12,
            fill: "BDBBBB",
            borderColor: "DDDBDB",
        });

        sheet1.cell("A1").value(mainTitle);
        const titleRange = sheet1.range(`A1:${endColumn}1`);
        titleRange.merged(true);
        titleRange.value(mainTitle);
        titleRange.style({
            horizontalAlignment: "center",
            verticalAlignment: "center",
            bold: true,
            fontSize: 12,
            fill: "E1DFDF"
        });
        widthObj.map(item => {
            sheet1.column(item.Key).width(item.Value);
        })

        if (total != "" && total > 0) {
            const totalAmountRow = sheetData.length + 2;
            sheet1.cell(`A${totalAmountRow}`).value("Total").style({
                bold: true,
            });
            sheet1.cell(`B${totalAmountRow}`).value(total).style({
                bold: true,
            });
        }

        return workbook.outputAsync().then((res) => {
            saveAs(res, extention);
        });
    });
}

export function exportDataExcelData(sheetData, mainTitle, widthObj, extention, totalAmount, TotalDiscount, TotalAdvance, TotalDeposit, TotalCGSTAmt, TotalSGSTAmt) {
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const sheet1 = workbook.sheet(0);
        const totalColumns = sheetData[0].length;
        const range = sheet1.usedRange();
        const endColumn = String.fromCharCode(64 + totalColumns);

        sheet1.cell("A2").value(sheetData);
        sheet1.range("A2:" + endColumn + "1").style({
            horizontalAlignment: "center",
            verticalAlignment: "center",
            bold: true,
            border: true,
            fontSize: 12,
            fill: "BDBBBB",
            borderColor: "DDDBDB",
        });

        sheet1.cell("A1").value(mainTitle);
        const titleRange = sheet1.range(`A1:${endColumn}1`);
        titleRange.merged(true);
        titleRange.value(mainTitle);
        titleRange.style({
            horizontalAlignment: "center",
            verticalAlignment: "center",
            bold: true,
            fontSize: 12,
            fill: "E1DFDF"
        });
        widthObj.map(item => {
            sheet1.column(item.Key).width(item.Value);
        })
        if (totalAmount != "" && totalAmount > 0) {
            const totalAmountRow = sheetData.length + 2;
            sheet1.cell(`D${totalAmountRow}`).value("Total").style({
                bold: true,
            });
            sheet1.cell(`E${totalAmountRow}`).value(TotalDiscount).style({
                bold: true,
            });
            sheet1.cell(`F${totalAmountRow}`).value(TotalAdvance).style({
                bold: true,
            });
            sheet1.cell(`G${totalAmountRow}`).value(TotalDeposit).style({
                bold: true,
            });
            sheet1.cell(`H${totalAmountRow}`).value(Math.round(TotalCGSTAmt)).style({
                bold: true,
            });
            sheet1.cell(`I${totalAmountRow}`).value(Math.round(TotalSGSTAmt)).style({
                bold: true,
            });
            sheet1.cell(`J${totalAmountRow}`).value(totalAmount).style({
                bold: true,
            });
        }

        return workbook.outputAsync().then((res) => {
            saveAs(res, extention);
        });
    });


}


export function exportDataExcelPurchaseBills(sheetData1, sheetData2, mainTitle, widthObj, extention, amountData) {
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const sheet1 = workbook.sheet(0);

        const totalColumns = sheetData1[0]?.length || 1;
        const endColumn = String.fromCharCode(64 + totalColumns);

        // 1. PURCHASE TABLE (First)
        sheet1.cell("A2").value(sheetData1);
        sheet1.range("A2:" + endColumn + '1').style({
            horizontalAlignment: "center",
            verticalAlignment: "center",
            bold: true,
            border: true,
            fontSize: 12,
            fill: "BDBBBB",
            borderColor: "DDDBDB",
        });

        // Main title for Purchase table
        sheet1.cell("A1").value(mainTitle);
        const titleRange = sheet1.range(`A1:${endColumn}1`);
        titleRange.merged(true);
        titleRange.value(mainTitle);
        titleRange.style({
            horizontalAlignment: "center",
            verticalAlignment: "center",
            bold: true,
            fontSize: 12,
            fill: "E1DFDF"
        });

        // Apply column widths
        widthObj.map(item => {
            sheet1.column(item.Key).width(item.Value);
        })

        // Calculate starting row for Transactions table (after Purchase table + 2 lines gap)
        const transactionsStartRow = sheetData1.length + 4;

        // 2. TRANSACTIONS TABLE (Second)
        if (sheetData2 && sheetData2.length > 0) {
            // Transactions title
            sheet1.cell(`A${transactionsStartRow}`).value("Transactions").style({
                horizontalAlignment: "center",
                verticalAlignment: "center",
                bold: true,
                border: true,
                fontSize: 12,
                fill: "BDBBBB",
                borderColor: "DDDBDB",
            });

            const headerrange = sheet1.range(`A${transactionsStartRow}:${endColumn}${transactionsStartRow}`);
            headerrange.merged(true);
            headerrange.value('Transactions');
            headerrange.style({
                horizontalAlignment: "center",
                verticalAlignment: "center",
                bold: true,
                fontSize: 12,
                fill: "E1DFDF"
            });

            // Transactions data
            const transactionsDataStartRow = transactionsStartRow + 1;
            sheet1.cell(`A${transactionsDataStartRow}`).value(sheetData2);

            // Style the transactions table
            const transactionsEndRow = transactionsDataStartRow + sheetData2.length - 1;
            sheet1.range(`A${transactionsDataStartRow}:${endColumn}${transactionsEndRow}`).style({
                horizontalAlignment: "center",
                verticalAlignment: "center",
                fontSize: 11
            });

            // Style the header row of transactions table
            sheet1.range(`A${transactionsDataStartRow}:${endColumn}${transactionsDataStartRow}`).style({
                bold: true,
                fill: "F0F0F0"
            });

            var totalsStartRow = transactionsEndRow + 3;
        } else {
            var totalsStartRow = sheetData1.length + 6;
        }

        // Left column block (A & B)
        sheet1.cell(`A${totalsStartRow}`).value("Total Amount").style({ bold: true });
        sheet1.cell(`B${totalsStartRow}`).value(amountData?.TotalAmount || 0);

        sheet1.cell(`A${totalsStartRow + 1}`).value("Total Paid Amount").style({ bold: true });
        sheet1.cell(`B${totalsStartRow + 1}`).value(amountData?.TotalPaidAmount || 0);

        sheet1.cell(`A${totalsStartRow + 2}`).value("Due Amount").style({ bold: true });
        sheet1.cell(`B${totalsStartRow + 2}`).value(amountData?.TotalUnpaidAmount);

        // Right column block (C & D)
        sheet1.cell(`C${totalsStartRow}`).value("Cash Amount").style({ bold: true });
        sheet1.cell(`D${totalsStartRow}`).value(amountData?.TotalCashAmount || 0);

        sheet1.cell(`C${totalsStartRow + 1}`).value("Pvt. Ltd. Amount").style({ bold: true });
        sheet1.cell(`D${totalsStartRow + 1}`).value(amountData?.TotalPvtLtdAmount || 0);

        sheet1.cell(`C${totalsStartRow + 2}`).value("Kiara Amount").style({ bold: true });
        sheet1.cell(`D${totalsStartRow + 2}`).value(amountData?.TotalKiaraAmount || 0);

        // Style the totals section
        sheet1.range(`A${totalsStartRow}:D${totalsStartRow + 2}`).style({
            horizontalAlignment: "left"
        });

        return workbook.outputAsync().then((res) => {
            saveAs(res, extention);
        });
    }).catch((error) => {
        console.error("Error creating Excel:", error);
    });
}

export function exportVendorAmountDataExcel(sheetData, mainTitle, widthObj, extention, amountData) {
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const sheet1 = workbook.sheet(0);
        const totalColumns = sheetData[0].length;
        const range = sheet1.usedRange();
        const endColumn = String.fromCharCode(64 + totalColumns);

        sheet1.cell("A2").value(sheetData);
        sheet1.range("A2:" + endColumn + "1").style({
            horizontalAlignment: "center",
            verticalAlignment: "center",
            bold: true,
            border: true,
            fontSize: 12,
            fill: "BDBBBB",
            borderColor: "DDDBDB",
        });

        sheet1.cell("A1").value(mainTitle);
        const titleRange = sheet1.range(`A1:${endColumn}1`);
        titleRange.merged(true);
        titleRange.value(mainTitle);
        titleRange.style({
            horizontalAlignment: "center",
            verticalAlignment: "center",
            bold: true,
            fontSize: 12,
            fill: "E1DFDF"
        });
        widthObj.map(item => {
            sheet1.column(item.Key).width(item.Value);
        })
        const totalAmountRow = sheetData.length + 6;

        sheet1.cell(`A${totalAmountRow}`).value("Total Amount").style({ bold: true });
        sheet1.cell(`B${totalAmountRow}`).value(amountData?.TotalAmount || 0);

        sheet1.cell(`A${totalAmountRow + 1}`).value("Total Paid Amount").style({ bold: true });
        sheet1.cell(`B${totalAmountRow + 1}`).value(amountData?.TotalPaidAmount || 0);

        sheet1.cell(`A${totalAmountRow + 2}`).value("Due Amount").style({ bold: true });
        sheet1.cell(`B${totalAmountRow + 2}`).value(amountData?.TotalUnpaidAmount);

        // Right column block (C & D)
        sheet1.cell(`C${totalAmountRow}`).value("Cash Amount").style({ bold: true });
        sheet1.cell(`D${totalAmountRow}`).value(amountData?.TotalCashAmount || 0);

        sheet1.cell(`C${totalAmountRow + 1}`).value("Pvt. Ltd. Amount").style({ bold: true });
        sheet1.cell(`D${totalAmountRow + 1}`).value(amountData?.TotalPvtLtdAmount || 0);

        sheet1.cell(`C${totalAmountRow + 2}`).value("Kiara Amount").style({ bold: true });
        sheet1.cell(`D${totalAmountRow + 2}`).value(amountData?.TotalKiaraAmount || 0);

        return workbook.outputAsync().then((res) => {
            saveAs(res, extention);
        });
    });
}

